var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconPopupArrow = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 32 11"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M0 10.013h31.483c-6.68-.103-12.276-3.746-13.977-8.681a2 2 0 0 0-.788-1.043 1.8 1.8 0 0 0-1.956-.001 2 2 0 0 0-.783 1.038C12.28 6.264 6.683 9.91 0 10.013",
  clipRule: "evenodd"
})));
export default SvgIconPopupArrow;